import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pause",
  "use": "icon-pause-usage",
  "viewBox": "0 0 35 35",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 35 35\" id=\"icon-pause\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M33 17.5C33 26.06 26.06 33 17.5 33 8.94 33 2 26.06 2 17.5 2 8.94 8.94 2 17.5 2 26.06 2 33 8.94 33 17.5Zm2 0C35 27.165 27.165 35 17.5 35S0 27.165 0 17.5 7.835 0 17.5 0 35 7.835 35 17.5ZM13.5 10a1.5 1.5 0 0 0-1.5 1.5v11a1.5 1.5 0 0 0 3 0v-11a1.5 1.5 0 0 0-1.5-1.5Zm8 0a1.5 1.5 0 0 0-1.5 1.5v11a1.5 1.5 0 0 0 3 0v-11a1.5 1.5 0 0 0-1.5-1.5Z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol